import { ModelResource } from './resource';
import { Deduction, DeductionCreditMemo } from '../models';

export class DeductionsCreditMemos extends ModelResource<DeductionCreditMemo> {
  model = DeductionCreditMemo;

  resourcePath = 'v1/deductions/credit-memos';

  async update(id: string, data, creditMemo?: DeductionCreditMemo) {
    const response = await this.api.patch(this.path(id), {
      data,
    });

    if (creditMemo) {
      creditMemo.updateFromJson(response.data);
    } else {
      creditMemo = DeductionCreditMemo.fromJson(response.data);
    }

    return creditMemo;
  }

  async refresh(id, creditMemo?: DeductionCreditMemo, userInstructions?: string) {
    const response = await this.api.post(this.path(id, 'refresh'), {
      data: userInstructions ? { user_instructions: userInstructions } : undefined,
    });

    if (creditMemo) {
      creditMemo.updateFromJson(response.data);
    } else {
      creditMemo = DeductionCreditMemo.fromJson(response.data);
    }

    return creditMemo;
  }

  async sync(id: string, deduction?: Deduction) {
    const response = await this.api.post(this.path(id, 'sync'));

    if (deduction) {
      deduction.updateFromJson(response.data);
    } else {
      deduction = Deduction.fromJson(response.data);
    }

    return deduction;
  }
}
